import React from "react";

function RightArrowSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="16"
      fill="none"
      viewBox="0 0 26 16"
    >
      <path
        fill="#9CA3AF"
        fillRule="evenodd"
        d="M16.669.469a1.6 1.6 0 012.262 0l6.4 6.4a1.6 1.6 0 010 2.262l-6.4 6.4a1.6 1.6 0 01-2.262-2.262L20.338 9.6H1.8a1.6 1.6 0 110-3.2h18.538l-3.669-3.669a1.6 1.6 0 010-2.262z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default RightArrowSvg;